import React, { useEffect } from "react";
import AppRoutes from "./Routes";

import "./App.scss";

// Imports
import AOS from "aos";
import "aos/dist/aos.css";

function App() {
  return (
    <div style={{ overflowX: "hidden" }}>
      <AppRoutes />
    </div>
  );
}

export default App;
